import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-bov-price-analysis',
  templateUrl: './bov-price-analysis.component.html',
  styleUrls: ['./bov-price-analysis.component.css']
})
export class BovPriceAnalysisComponent implements OnInit {

  @Input() propertyId: number;
  constructor() { }

  ngOnInit() {
  }

}
